import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../styles/game/ResultHistory2.css";
import "../../styles/game/ResultHistory.css";
import { useSocket } from '../../providers/SocketContext.jsx'
import { useEffect } from "react";
import FairnessModal from './FairnessModal.jsx';
import { useAuth } from "../../providers/AuthProvider.jsx";
import { t } from "i18next";
function ResultHistory2() {
    const socket = useSocket();
    const { user } = useAuth
    const [initialResults, setInitialResults] = useState([]);
    const [isVisible, setIsVisible] = useState(!document.hidden);
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);
    const [isFairnessOpen, setIsFairnessOpen] = useState(false)
    const [roundId, setRoundId] = useState(0)
    const [isAnimating, setIsAnimating] = useState(false);
    const [roundQueue, setRoundQueue] = useState(null)
    const closeFairnessModal = () => {
        setTimeout(() => {
            setIsFairnessOpen(false);
        }, 200)
    }

    // useEffect(() => {
    //     // Обработчик изменения видимости
    //     const handleVisibilityChange = () => {
    //         setIsVisible(!document.hidden);
    //     };
    //     if (document.hidden) {
    //         console.log("Browser is hidden, skipping animations.");
    //         console.log(!document.hidden)
    //     }
    //     document.addEventListener("visibilitychange", handleVisibilityChange);

    //     return () => {
    //         document.removeEventListener("visibilitychange", handleVisibilityChange);
    //     };
    // }, [isVisible]);

    useEffect(() => {
        // Обработчик изменения видимости
        const handleVisibilityChange = () => {
            const isNowVisible = !document.hidden;
            setIsVisible(isNowVisible);
    
            if (isNowVisible) {
                console.log("Browser is visible again, refreshing results...");
                // Логика обновления данных
                if (socket) {
                    socket.emit('get_rounds_results'); // Повторный запрос данных с сервера
                }
            }
        };
    
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [socket]);

    // useEffect(() => {
    //     if (!socket) {
    //         return
    //     }

    //     socket.on('connect', () => {
    //         socket.emit('get_rounds_results')
    //     })
        
    //     return () => {
    //         socket.off('connect')
    //     }
    // }, [socket])

    useEffect(() => {
        if (!socket) {
            return
        }

        socket.on('rounds_result', (res) => {
            setInitialResults([...res])
            console.log(res)
            console.log('ROUNDS RESULT CONSOLE LOG')
        })
        
        return () => {
            socket.off('rounds_result')
        }
    }, [socket])

    useEffect(() => {
        if(!socket) {
            return
        }

        socket.on('roundRes', (id, roundResult) => {
            if(!isAnimating) {
                setInitialResults((prevResults) => [
                    { id, roundResult },
                    ...prevResults,
                ]);
                // console.log('ROUNDRES 123123')
            } else {
                setRoundQueue({ id, roundResult })
            }
            
        })

        return () => {
            socket.off('roundRes');
        };

    }, [socket, isAnimating])

    useEffect(() => {
        if(!isAnimating) {
            if(roundQueue !== null) {
                setInitialResults((prevResults) => [
                    { id: roundQueue.id, roundResult: roundQueue.roundResult },
                    ...prevResults,
                ]);
                setRoundQueue(null);
            }
        }
    }, [isAnimating])

    const addResult = (newValue) => {
        if(!isAnimating) {
            setInitialResults((prevResults) => [
                { id: newValue.id, roundResult: newValue.roundResult },
                ...prevResults,
            ]);
        } else {
            setRoundQueue({ id: newValue.id, roundResult: newValue.roundResult })
        }
    };


    const dropDownRenderPayout = (result, index) => {
        
        const numericValue = parseFloat(result.roundResult).toFixed(2);
        const formattedValue = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numericValue);

        let color;
        if (numericValue >= 2 && numericValue < 10) {
            color = "rgb(145, 62, 248)";
        } else if (numericValue >= 10) {
            color = "rgb(192, 23, 180)";
        } else if (numericValue < 2.0) {
            color = "rgb(52, 180, 255)";
        }

        return (
            <div
                style={{ color }}
                className="payout-wrapper dropdown"
                onClick={() => {
                    setRoundId(result.id)
                    setIsFairnessOpen(true)
                    // console.log(roundId)
                }}
            >
                {formattedValue}x
            </div>
        );
    };

    const renderPayout = (result, index) => {
        
        const numericValue = parseFloat(result.roundResult).toFixed(2);
        const formattedValue = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numericValue);

        let color;
        if (numericValue >= 2 && numericValue < 10) {
            color = "rgb(145, 62, 248)";
        } else if (numericValue >= 10) {
            color = "rgb(192, 23, 180)";
        } else if (numericValue < 2.0) {
            color = "rgb(52, 180, 255)";
        }

        return (
            <motion.div
                key={`${result.id}`}
                className="payout-wrapper"
                style={{ color }}
                layout // Плавное перемещение для всех
                initial={
                    isVisible
                        ? index === 0
                            ? { opacity: 1, scale: 2, x: -50 }
                            : { opacity: 1 }
                        : { opacity: 0, scale: 1 } // Значения по умолчанию для скрытой вкладки
                }
                animate={
                    isVisible
                        ? index === 0
                            ? { scale: 1, x: 0 }
                            : { opacity: 1 }
                        : { opacity: 0 } // Значения для скрытой вкладки
                }
                exit={
                    isVisible
                        ? index === 0
                            ? { opacity: 0, scale: 1, x: 0 }
                            : { opacity: 0 }
                        : { opacity: 0 } // Значения для скрытой вкладки
                }
                transition={{ duration: 1.1, ease: "easeInOut" }}
                onAnimationComplete={(definition) => {
                    if(index === 0) {
                        setIsAnimating(false);
                        // console.log("Animation Complete:", definition);
                    }
                }}
                onAnimationStart={(definition) => {
                    if(index === 0) {
                        setIsAnimating(true)
                        // console.log("Animation Started:", definition)
                    }
                }}
            onClick={() => {
                                setRoundId(result.id)
                                setIsFairnessOpen(true)
                                // console.log(roundId)
                            }}>
                {formattedValue}x
            </motion.div>
        );
    };

    return (
        <>
        <div className="result-history-wrapper">
            <div className="payouts-wrapper">
                <motion.div layout className="payout-container">
                    <AnimatePresence>
                        {initialResults.map((result, index) => renderPayout(result, index))}
                        
                    </AnimatePresence>
                </motion.div>
                {/*<button*/}
                {/*    onClick={() => {*/}
                {/*        addResult({ id: 20, roundResult: "3.05"});*/}
                {/*    }}*/}
                {/*>*/}
                {/*    Add Result*/}
                {/*</button>*/}
            </div>
            <div className={'history-shadow'}></div>
            <div className={'history-dropdown-wrapper'} onClick={() => setIsHistoryOpen((prev) => !prev)}>
                <div className={'history-dropdown-btn'}>
                    <div className={"trigger-wrap"}>
                        {/* <div className={`history-icon-wrap ${isHistoryOpen ? "open" : ""}`}></div>
                        <div className={`history-arrow-wrap ${isHistoryOpen ? "open" : ""}`}></div> */}
                        <div className={`history-icon-more ${isHistoryOpen ? "close" : ""}`}></div>
                    </div>
                </div>
            </div>
            <div className={`history-stats-dropdown ${isHistoryOpen ? "open" : ""}`}>
                <div className={"stats-dropdown-wrap"}>
                    <div className={"stats-dropdown-wrap-header"}>
                        <div className={'lining-nums-tabular-nums'}>{t("round_history")}</div>
                    </div>
                    <div className={"stats-dropdown-payouts-block"}>
                    {initialResults.map((result, index) => dropDownRenderPayout(result, index))}
                    </div>
                </div>
            </div>
        </div>
        {isFairnessOpen && <FairnessModal isOpen={isFairnessOpen} onClose={closeFairnessModal} roundId={roundId}/>}
        </>
    );
}

export default ResultHistory2;